import { createAction } from '@reduxjs/toolkit';

export const toggleOrderDetailGrossPrice = createAction('settings/toggleOrderDetailGrossPrice');

export const togglePunchingOrderGrossPrice = createAction('settings/togglePunchingOrderGrossPrice');
